module.exports = __webpack_public_path__ + "1d34d28bc90c5b884114462fadd7ddee.svg";